import React, { useEffect } from "react";
import { Link } from "react-router";
import "./Uvod.scss";

import { LOGOUT_USER } from "../../../redux/actions/authActions";
import { useDispatch, useSelector } from "../../../redux/store";
import SeznamPonuk from "../CenovePonuky/SeznamPonuk";

interface Props {}

const Uvod: React.FC<Props> = ({}: Props) => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="uvod">
      <div className="up">
        <div className="name">
          {auth.user.firstName} {auth.user.lastName}
        </div>
        <div>
          <Link to="/cenove-ponuky">Cenové ponuky</Link>
        </div>
        <div>
          <Link to="/zfadl">Zálohové faktúry</Link>
        </div>
        <div>
          <Link to="/zfadl">Dodacie listy</Link>
        </div>
        <div className="logout" onClick={() => dispatch(LOGOUT_USER())}>
          Odhlásiť sa
        </div>
      </div>
      <div className="down">
        <div className="title">NOVÉ CENOVÉ PONUKY</div>
        <SeznamPonuk shown onlyNew />
      </div>
    </div>
  );
};

export default Uvod;
